import React from 'react';
import { MessageText } from 'stream-chat-react';
import './SimplePinnedMessage.css';

export const SimplePinnedMessage = () => {




  return (
    
   
        <MessageText /> 
   
  );
};
